
import Swal from 'sweetalert2';

const CLIENT_URL = 'https://apisandbox.symptohealth.com';

export const symptoReq = async (url: string, params = {}, headers = {}) => {
	const resp = await (await fetch(`${CLIENT_URL}${url}`, {
	  "headers": {
	    "accept": "application/json, text/plain, */*",
	    "accept-language": "en-US,en;q=0.9",
			"cache-control": "no-cache",
			"content-type": "application/json;charset=UTF-8",
			"pragma": "no-cache",
			"Referer": "https://app.symptohealth.com/",
			"Referrer-Policy": "strict-origin-when-cross-origin",
			...headers
	  },
	  "referrer": "https://app.symptohealth.com/",
	  "referrerPolicy": "strict-origin-when-cross-origin",
	  ...params
	})).json();
	if (resp.Status !== 'OK') {
    Swal.fire({
      title: 'Error',
      text: `Failed ${url}. ${JSON.stringify(resp)}`,
      icon: 'error',
      confirmButtonText: 'OK'
    });
		throw new Error(`Failed ${url}. ${JSON.stringify(resp)}`)
	}
	return resp.Response;
};

export const generateAuthCode = async ({
	username,
  password,
}: {
	username: string,
	password: string,
}): Promise<{
	authCode: string, rateToken: string,
}> => {
  console.log("\n\n\nAuthenticating user...");
  try {
    const authCode = await symptoReq(`/authorization`, {
      body: JSON.stringify({
				clientId: username,
      	clientSecret: password,
			}),
			method: 'POST',
    });
    console.log("User authenticated");
		const rateToken = await symptoReq(`/authorization/rateToken`, {
			method: 'GET',
    }, {'Authorization': `Bearer ${authCode}` });
    console.log("Rate token generated");
    return { authCode, rateToken };
  } catch (e) {
    console.log(e);
    Swal.fire({
      title: 'Error',
      text: `Errored on generating bearer token`,
      icon: 'error',
      confirmButtonText: 'OK'
    });
    throw e;
  }
}
